import React, { Fragment } from "react";

import "./PDP.css";
import Footer from "../Footer/Footer";

import { Container, Table } from "react-bootstrap";
import { Helmet } from "react-helmet";
import MetaTags from 'react-meta-tags';

import { Product } from "schema-dts";
import { helmetJsonLdProp } from "react-schemaorg";


function pdp(props) {

  

  const amazonBlockFunction = () => {
    
  if (!(props.product.amazonOfferPrice=="0")){
    return (
    <tr>
    <td>
      {" "}
      <img
        src="/img/amazon-logo.png"
        width="60px"
        height="20px"
        alt="amazon"
      />{" "}
    </td>
    <td className="price"> ₹ {props.product.amazonOfferPrice} </td>
    <td>
      {" "}
      <button type="button" className="btn btn-success ">
        {" "}
        <a
          className="go-to-store-button-link"
          href={props.product.amazonURL}
        >
          Go to Store
        </a>{" "}
      </button>{" "}
    </td>
  </tr>
  
  );
    }
  }

  const flipkartBlockFunction = () => {
    if (!(props.product.flipkartOfferPrice=="0")){
      return (
      <tr>
      <td>
        {" "}
        <img
          src="/img/flipkart-logo.png"
          width="60px"
          height="20px"
          alt="flipkart"
        />{" "}
      </td>
      <td className="price"> ₹ {props.product.flipkartOfferPrice} </td>
      <td>
        {" "}
        <button type="button" className="btn btn-success ">
          {" "}
          <a
            className="go-to-store-button-link"
            href={props.product.flipkartURL}
          >
            Go to Store
          </a>{" "}
        </button>{" "}
      </td>
    </tr>
    
  
    );
      }
    }
  

  const getProductDescription = () => {
    if (props.product.productCategory === "mobiles") {
      return (
        <React.Fragment>

          <h3 className="font-size-24 mb-3">Display</h3>
          <p className="mb-6">{props.product.productDisplayDescription}</p>
          <h3 className="font-size-24 mb-3">Performance</h3>
          <p className="mb-6">{props.product.productPerformanceDescritption}</p>
          <h3 className="font-size-24 mb-3">Camera</h3>
          <p className="mb-6">{props.product.productCameraDescription}</p>
          <h3 className="font-size-24 mb-3">Battery</h3>
          <p className="mb-6">{props.product.productBatteryDescription}</p>         
          
        </React.Fragment>
      );
    } else if (props.product.productCategory === "games") {
      return (
        <React.Fragment>
          <h3 className="font-size-24 mb-3">Product Description</h3>
          <p className="mb-6">{props.product.productLongDescription}</p>         
        </React.Fragment>
      );
    }
  };

  const productSpecification = () => {
    if (props.product.productCategory === "mobiles") {
      return (
        <Fragment>
            <tr>
            <th className="px-4 px-xl-5">Processor</th>
             <td>{props.specification.Processor}</td>
              
            </tr>
            <tr>
              <th className="px-4 px-xl-5">Display</th>
              <td>{props.specification["Display"]}</td>              
            </tr>
            <tr>
            <th className="px-4 px-xl-5">RAM</th>
              <td>{props.specification["RAM"]}</td>
            </tr>
            <tr>
            <th className="px-4 px-xl-5">Storage</th>
              <td>{props.specification["Storage"]}</td>
            </tr>
            <tr>
            <th className="px-4 px-xl-5">Rear Camera</th>
              <td>{props.specification["Rear Camera"]}</td>
            </tr>
            <tr>
            <th className="px-4 px-xl-5">Battery</th>
              <td>{props.specification["Battery"]}</td>
            </tr>
            <tr>
              <th className="px-4 px-xl-5">Dimensions</th>
              <td>{props.specification["Dimensions"]}</td>
            </tr>
            <tr>
            <th className="px-4 px-xl-5">Weight</th>
              <td>{props.specification["Weight"]}</td>
            </tr>
            
            <tr>
            <th className="px-4 px-xl-5">Selfie Camera</th>
              <td>{props.specification["Selfie"]}</td>
            </tr>
            </Fragment>
        
      );
    } else if (props.product.productCategory === "books") {
      return (
        <Fragment>
            <tr>
            <th className="px-4 px-xl-5">Publisher</th>
              <td>{props.specification["Publisher"]}</td>
            </tr>
            <tr>
            <th className="px-4 px-xl-5">Language</th>
              <td>{props.specification["Language"]}</td>
            </tr>
            <tr>
            <th className="px-4 px-xl-5">ISBN-10</th>
              <td>{props.specification["ISBN-10"]}</td>
            </tr>
            <tr>
            <th className="px-4 px-xl-5">Product Dimensions</th>
              <td>{props.specification["Product Dimensions"]}</td>
            </tr>
            </Fragment>
         
      );
    } else if (props.product.productCategory === "games") {
      return (
        <Fragment>
            <tr>              
              <th className="px-4 px-xl-5">Release Date</th>
              <td>{props.specification["Release Date"]}</td>
            </tr>
            <tr>            
              <th className="px-4 px-xl-5">Item Weight</th>
              <td>{props.specification["Item Weight"]}</td>
            </tr>
            </Fragment>
         
      );
    }
  };
  

  return (
   
      <Container>
        <Helmet>
        <meta charSet="utf-8" />
        <title>{props.product.productName}</title>
        <meta name="description" content={props.product.productName} />
        <meta name="keywords" content={props.product.productCategory} />
        <link rel="canonical" href={`https://shopmuthu.com/${props.product.productCategory}/${props.product.productURL}`} />

        <meta name="og_title" property="og:title" content={props.product.productName} />
	      <meta name="og_url" property="og:url" content={`https://shopmuthu.com/${props.product.productCategory}/${props.product.productURL}`} />
	      <meta name="og_type" property="og:type" content="website" />
		    <meta name="og_image" property="og:image" content={props.product.productMainImage} />
		    <meta name="og_site_name" property="og:site_name" content="shopmuthu" />
	      <meta name="og_description" property="og:description" content={props.product.productShortDescription} />

	      <meta name="twitter:card" content = "summary" />
	      <meta name="twitter:site" content="@shopmuthu" />
	      <meta name="twitter:creator" content="@shopmuthu" />
	      <meta name="twitter:title" content={props.product.productName} />
	      <meta name="twitter:description" content={props.product.productShortDescription} />
		    <meta name="twitter:image" content={props.product.productMainImage} />

        {/* inline script elements */}
    <script type="application/ld+json">{`
       {
        "@context": "https://schema.org/",
        "@type": "Product",
        "name": "${props.product.productName}",
        "image": [
          "${props.product.productMainImage}"
         ],
        "description": "${props.product.productShortDescription}",
        "sku": "",
        "mpn": "",
        "brand": {
          "@type": "Brand",
          "name": "${props.product.productBrand}"
        },
        "review": {
          "@type": "Review",
         
          "author": {
            "@type": "Person",
            "name": "ShopMuthu"
          }
        },
       
        "offers": {
          "@type": "Offer",
          "url": "${props.product.productURL}",
          "priceCurrency": "INR",
          "price": "${props.product.amazonOfferPrice}",          
          "itemCondition": "https://schema.org/NewCondition",
          "availability": "https://schema.org/InStock",
          "seller": {
            "@type": "Organization",
            "name": "shopmuthu"
          }
        }
      }
    `}</script>

    {/* noscript elements */}
        

      </Helmet>
        <main id="content" role="main">
            {/* breadcrumb */}
            <div className="bg-gray-13 bg-md-transparent">
                <div className="container">
                    {/* breadcrumb */}
                    <div className="my-md-3">
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb mb-3 flex-nowrap flex-xl-wrap overflow-auto overflow-xl-visble">
                                <li className="breadcrumb-item flex-shrink-0 flex-xl-shrink-1"><a href="/">Home</a></li>
                                <li className="breadcrumb-item flex-shrink-0 flex-xl-shrink-1 active" aria-current="page"><a href={`/category/${props.product.productCategory}`}> {props.product.productCategory}</a></li>                                
                            </ol>
                        </nav>
                    </div>
                    {/* End breadcrumb */}
                </div>
            </div>
            {/* End breadcrumb */}
            <div className="container">
                {/* Single Product Body */}
                <div className="mb-xl-14 mb-6">
                    <div className="row">
                        <div className="col-md-5 mb-4 mb-md-0">
                           
                                <div className="js-slide">
                                    <img className="img-mob" src={props.product.productMainImage} alt={props.product.productName}/>
                                </div>            
                         

                            
                        </div>
                        <div className="col-md-7 mb-md-6 mb-lg-0">
                            <div className="mb-2">
                                <div className="border-bottom mb-3 pb-md-1 pb-3">
                                    <a href={`/category/${props.product.productCategory}`} className="font-size-12 text-gray-5 mb-2 d-inline-block">{props.product.productCategory}</a>
                                    <h2 className="font-size-25 text-lh-1dot2">{props.product.productName}</h2>
                                                                       
                                </div>
                            
                                <div className="mb-2">
                                    <ul className="font-size-14 pl-3 ml-1 text-gray-110">
                                        <li>{props.product.keySpecification1}</li>
                                        <li>{props.product.keySpecification2}</li>
                                        <li>{props.product.keySpecification3}</li>
                                        <li>{props.product.keySpecification4}</li>
                                        <li>{props.product.keySpecification5}</li>
                                    </ul>
                                </div>                                
                             
                              
                                <div className="d-md-flex align-items-end mb-3">
                                <Table>
                                          <caption>Last updated: {props.product.lastUpdatedTime}</caption>

                                          <tbody>
                                          

                                          {amazonBlockFunction()}
                                          {flipkartBlockFunction()}
                                           
                                          </tbody>
                                        </Table>
                                  
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* End Single Product Body */}

                {/*Description*/}

                <div className="tab-pane" id="Jpills-two-example1" role="tabpanel" aria-labelledby="Jpills-two-example1-tab">
                                <h3 className="font-size-24 mb-3">Product Description</h3>
                                <p>{props.product.productShortDescription}</p>
                                <div className="row">
                                    <div className="col-md-6">
                                        <div className="pt-lg-8 pt-xl-10">
                                        {getProductDescription()}
                                        </div>
                                    </div>                                 
                                   
                                </div>
                              
                            </div>

                {/* End Description */}

                 {/*Specification*/}
                <div className="tab-pane"  aria-labelledby="Jpills-three-example1-tab">
                                <div className="mx-md-5 pt-1">
                                    
                                    <h3 className="font-size-18 mb-4"> Specifications</h3>
                                    <div className="table-responsive">
                                        <table className="table table-hover">
                                            <tbody>
                                                <tr>
                                                    <th className="px-4 px-xl-5 border-top-0"></th>
                                                    <td className="border-top-0"></td>
                                                </tr>
                                                {productSpecification()}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                             {/*End Specification*/}
                             
                              
            </div>
        </main>
        
        <Footer/>
        </Container>

        


        );
}

export default pdp;
